import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';

import PathStatusComponent, { styles } from './PathStatusComponent';

const mapStateToProps = ({
  journeyBuilderArea: {
    JourneyBuilderSettings: { decisionSplitObjects },
  },
}) => ({
  objects: decisionSplitObjects,
});

export default compose(
  connect(
    mapStateToProps,
    null
  ),
  injectIntl,
  withStyles(styles)
)(PathStatusComponent);



// WEBPACK FOOTER //
// ./src/JourneyBuilder/DecisionSplit/components/Path/PathStatus.js